export default __webpack_public_path__ + "static/media/060_corner2_02.ea5ec093.mp3";